import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { ExceptionLogService } from '../../business-services/exception-log.service';
import { ExceptionLogListModel, ExceptionLogListRequestModel } from '../../business-entities/exception-log-model';
import { AdminCommonService } from '../../services/admin-common.service';
import { DatePipe } from '@angular/common';
import { ExceptionLogComponent } from '../exception-log/exception-log.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-exception-log-list',
  templateUrl: './exception-log-list.component.html',
})

export class ExceptionLogListComponent implements OnInit {

  appointmentErrorLogList: ExceptionLogListModel[] = [];
  totalCount = 0;
  throttle = 100;
  scrollDistance = 1;
  dateRange: any[] = [];
  isTodayViewOn: boolean = true;
  isWeekViewOn: boolean = false;
  todayViewDate: any;
  weekViewDate: any;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  appointmentErrorLogRequestModel: ExceptionLogListRequestModel = {
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    moduleId: 0,
    logDate: '',
  };

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    private service: ExceptionLogService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private adminCommonService: AdminCommonService,
    private datePipe: DatePipe,

  ) { }

  ngOnInit() {
    this.service.currentViewType.subscribe(viewType => {
      if (viewType === 1) {
        this.loadTodayView();
      } else if (viewType === 2) {
        this.loadWeekView();
      } else {
        this.loadTodayView(); 
      }
    });
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.appointmentErrorLogRequestModel.sortDirection = direction;
    this.appointmentErrorLogRequestModel.sortColumn = column;
    this.appointmentErrorLogRequestModel.startRecordNumber = 0;
    this.appointmentErrorLogList = [];
    this.getAppointmentErrorLogList(this.appointmentErrorLogRequestModel);
  }

  onClickChangeView(isWeek: boolean) {
    if (isWeek) {
      this.loadWeekView();
    } else {
      this.loadTodayView();
    }
  }

  refresh() {
    this.appointmentErrorLogRequestModel.startRecordNumber = 0;
    this.appointmentErrorLogList = [];
    this.getAppointmentErrorLogList(this.appointmentErrorLogRequestModel);
  }

  loadTodayView() {
    this.isTodayViewOn = true;
    this.isWeekViewOn = false;
    let todays_date = new Date();

    this.weekViewDate = this.datePipe.transform(todays_date, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(todays_date, 'dd/MM/yyyy');
    this.dateRange=[];
    this.dateRange.push(todays_date);
    this.dateRange.push(todays_date);
    this.todayViewDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.appointmentErrorLogRequestModel.logDate = this.todayViewDate;
    this.appointmentErrorLogList = [];
    this.appointmentErrorLogRequestModel.startRecordNumber = 0;
    this.getAppointmentErrorLogList(this.appointmentErrorLogRequestModel);
  }

  loadWeekView() {
    this.isTodayViewOn = false;
    this.isWeekViewOn = true;
    const { weekViewDate, bookingDate } = this.adminCommonService.getWeekViewDatesNew(1);
    this.dateRange = [...bookingDate];
    this.appointmentErrorLogRequestModel.logDate = weekViewDate;
    this.appointmentErrorLogList = [];
    this.getAppointmentErrorLogList(this.appointmentErrorLogRequestModel);
  }

  onDateRangeChanged(event: any) {
    this.dateRange = (typeof event === 'undefined') ? [] : event;
    let dateRangeFormatted= this.getFormattedDate(this.dateRange);
    if (dateRangeFormatted == "") {
      this.loadTodayView();
      return;
    }
    this.appointmentErrorLogRequestModel.startRecordNumber = 0;
    this.appointmentErrorLogList = [];
    this.getAppointmentErrorLogList(this.appointmentErrorLogRequestModel);
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.appointmentErrorLogList.length) {
      this.appointmentErrorLogRequestModel.startRecordNumber = this.appointmentErrorLogList.length;
      this.getAppointmentErrorLogList(this.appointmentErrorLogRequestModel);
    }
  }

  monthDiff(d1: any, d2: any) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    if (d2.getDate() >= d1.getDate())
      months++
    return months <= 0 ? 0 : months;
  }

  getAppointmentErrorLogList(requestModel: ExceptionLogListRequestModel): void {
      let dateRangeFormatted= this.getFormattedDate(this.dateRange);
      let startDate = new Date(this.datePipe.transform(this.dateRange[0], 'MM/dd/yyyy'));
      let endDate = new Date(this.datePipe.transform(this.dateRange[1], 'MM/dd/yyyy'));
      if (this.monthDiff(startDate, endDate) >= 3) {
        let addedMsg = this.translate.instant('lbldaterangeForThreeMonths');
        this.toastr.warning(addedMsg);
        return;
      }
      this.appointmentErrorLogRequestModel.logDate = dateRangeFormatted;
    this.spinner.show();
    this.service.GetErrorLogList(requestModel)
      .then((response) => {
        if (response.responseCode == Constant.SuccessResponseCode) {
          this.appointmentErrorLogList.push(...response.responseObject);
          this.totalCount = this.appointmentErrorLogList.length > 0 ? this.appointmentErrorLogList[0].totalCount : 0;
        }

        else if (response.responseObject && response.responseObject.errorCount > 0) {
          if (response.responseObject.result &&
            response.responseObject.result.errorCode === Enums.ErrorCodes.InvalidIdCode) {
            this.spinner.hide();
          }
          this.toastr.error(response.responseMessage);
        }
      })
      .finally(() => {
        this.spinner.hide();
      });
  }

  viewException(result: any) {
    let modelHeadermsg = "";
    modelHeadermsg = result.controllerName
    const modalRef = this.modalService.open(ExceptionLogComponent, { size: 'lg' });
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.exceptionLog = result;
  }
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}